module.exports = __webpack_public_path__ + "static/media/special.faecb5da.mp3";